import React, { forwardRef } from 'react';
import styled, { css } from 'styled-components';
import { FlexDirectionProps, HeightProps, SpaceProps } from 'styled-system';
import { Flex, IFlexProps } from '../Flex/Flex.component';

const Container = styled(Flex)<{ noOverflow?: boolean }>`
  position: relative;
  ${({ noOverflow }) =>
    !noOverflow &&
    css`
      overflow: auto;
    `}

  flex-grow: 1;
`;

export interface IPageBodyProps extends SpaceProps, IFlexProps, FlexDirectionProps, HeightProps {
  subject?: string;
  // Tp support the migration of the new PageHeader templates
  noOverflow?: boolean;
  className?: string;
  children: React.ReactNode;
  ref?: React.Ref<HTMLDivElement>;
  fullHeight?: boolean; // TODO: check if it's real
  fullWidth?: boolean; // TODO: check if it's real
}

export const PageBody = forwardRef<HTMLDivElement, IPageBodyProps>(
  ({ children, subject, flexDirection = 'column', ...props }, ref) => (
    <Container ref={ref} subject={subject} flexDirection={flexDirection} {...props}>
      {children}
    </Container>
  ),
);

PageBody.displayName = 'PageBody';
